import "./common";
export function getUrlParam(name = '', url = '') {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
export function getLanguage(paramName = 'lang') {
    return getUrlParam(paramName) || 'ja';
}
export function getDetailsUrl(id) {
    let lang = getLanguage();
    let focus = getUrlParam('focus') ? '&focus=1' : '';
    let type = getUrlParam('type');
    type = type ? `&type=${type}` : '';
    lang = lang ? `lang=${lang}&` : '';
    return `index.html?${lang}page=details&id=${id}${type}${focus}`;
}
export function getListUrl() {
    let lang = getLanguage() || '';
    const listUrl = window.location.href.replace(/\?.+/gi, '');
    return listUrl + '?lang=' + lang;
}
export function selectLanguage(lang) {
    const selectedLang = lang || 'ja';
    //1. remove lang in the url
    let newUrl = location.href.replace(/&?lang=\w{2}&?/gi, '');
    // //2. check whether html file  is included in the url
    // newUrl =
    //     newUrl + (!newUrl.includes('.html') ? 'index.html' : '');
    //3. add lang at the end of url
    const langQueryString = (!newUrl.includes('?') ? '?' : newUrl.includes('&') ? '&' : '&') +
        `lang=${selectedLang}`;
    newUrl = newUrl + langQueryString;
    document.location.href = newUrl;
}
export function currentLangIsJapanese() {
    return getLanguage() === 'ja';
}
